import { BlockStyleDto, ContractDto, TextBlockDto } from '../Types/DocumentT';
import { ajaxActions } from './AjaxActions';
import { ToastS } from './ToastS';

const BASE_URL = `${process.env.REACT_APP_DOCUMENT_SERVICE_URL}`;

const fetchById = async (id: number): Promise<ContractDto | null> => {
  const res = await ajaxActions.get(`${BASE_URL}/contracts/${id}`);
  if (res.ok) {
    return res.json();
  }
  return null;
};

const edit = async (id: number, patch: Partial<ContractDto>): Promise<ContractDto | null> => {
  const res = await ajaxActions.patch(`${BASE_URL}/contracts/${id}`, patch);
  if (res.ok) {
    return res.json();
  }
  return null;
};

const removeTextBlock = async (blockId: number, contractId: number) => {
  const res = await ajaxActions.del(`${BASE_URL}/textBlocks/${blockId}/contract/${contractId}`);
  if (res.ok) {
    ToastS.info('p-removed', 'Absatz entfernt');
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const addBlockAbove = async (
  contractId: number,
  blockId?: number,
  blockDto?: Partial<TextBlockDto>,
): Promise<ContractDto | null> => {
  const res = await ajaxActions.put(
    `${BASE_URL}/contracts/${contractId}/aboveTextBlocks${blockId ? `?afterTextBlock=${blockId}` : ''}`,
    blockDto,
  );
  if (res.ok) {
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const addBlockBelow = async (
  contractId: number,
  blockId?: number,
  blockDto?: Partial<TextBlockDto>,
): Promise<ContractDto | null> => {
  const res = await ajaxActions.put(
    `${BASE_URL}/contracts/${contractId}/belowTextBlocks${blockId ? `?afterTextBlock=${blockId}` : ''}`,
    blockDto,
  );
  if (res.ok) {
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const moveBlock = async (
  contractId: number,
  fromIndex: number,
  toIndex: number,
  fromBelow: boolean,
  toBelow: boolean,
): Promise<ContractDto | null> => {
  const res = await ajaxActions.patch(
    `${BASE_URL}/contracts/${contractId}/move?fromIndex=${fromIndex}&toIndex=${toIndex}&fromBelow=${fromBelow}&toBelow=${toBelow}`,
    null,
  );
  if (res.ok) {
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const editBlockStyle = async (id: number, patch: Partial<BlockStyleDto>): Promise<BlockStyleDto | null> => {
  const res = await ajaxActions.patch(`${BASE_URL}/blockStyles/${id}`, patch);
  if (res.ok) {
    return res.json();
  }
  return null;
};

const editTextBlock = async (blockId: number, patch: Partial<TextBlockDto>): Promise<TextBlockDto | null> => {
  const res = await ajaxActions.patch(`${BASE_URL}/textBlocks/${blockId}`, patch);
  if (res.ok) {
    return res.json();
  }
  return null;
};

const insertPositions = async (
  blockId: number,
  contractId: number,
  documentId: number,
): Promise<ContractDto | null> => {
  const res = await ajaxActions.put(
    `${BASE_URL}/textBlocks/${blockId}/contract/${contractId}/insertPositions/${documentId}`,
  );
  if (res.ok) {
    return res.json();
  }
  return null;
};

// eslint-disable-next-line import/prefer-default-export
export const ContractS = {
  fetchById,
  edit,
  removeTextBlock,
  addBlockAbove,
  addBlockBelow,
  insertPositions,
  moveBlock,
  editBlockStyle,
  editTextBlock,
};
